module.exports = __webpack_public_path__ + "img/1-web.cc4e52a2.jpg";